import { Component, OnInit, Input, EventEmitter, Output } from '@angular/core';
import { PHBHPLayoutPackageService } from "../ph-bhp-layout-package.service";
@Component({
  selector: 'lib-ph-bhp-sidepanel',
  templateUrl: './ph-bhp-sidepanel.component.html',
  styleUrls: ['./ph-bhp-sidepanel.component.css']
})
export class PHBHPSidepanelComponent implements OnInit {

  @Input() showsidebar;
  @Input() userData;
  @Input() isFilterCard: boolean = false;

  @Output() childData = new EventEmitter();
  emitData: any = {
    key: "",
    val: ""
  }
  constructor(public layoutService: PHBHPLayoutPackageService) { }

  ngOnInit() {
   
  }

  ngOnChanges() {
    
  }

  closepanel() {
    this.emitData = {};
    this.emitData.key = "close";
    this.emitData.val = false;
    this.childData.emit(this.emitData);
  }
}
